import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ButtonStyle } from './Button';
import { ActionBar, ActionBarStyle } from './ActionBar';

export interface AuthActionsBarProps extends RouteComponentProps<any> {}

const actions = (props: AuthActionsBarProps) => [
  {
    className: ButtonStyle.Normal,
    label: 'Register',
    handler: () => props.history.push('/register'),
  },
  {
    className: ButtonStyle.Normal,
    label: 'Login',
    handler: () => props.history.push('/login'),
  },
];

export const AuthActionsBar = (props: AuthActionsBarProps) => (
  <ActionBar className={ActionBarStyle.alignCenter} actions={actions(props)} />
);

export default AuthActionsBar;
